/** Score formatting shared by the player cards, the game-over card and bar, and the move history. */

/** U+2212 MINUS SIGN: the typographic minus, the same width as a digit in tabular figures. */
export const MINUS = '−';

/** 12 → "12", −10 → "−10" (a real minus sign, never an ASCII hyphen). */
export function formatScore(n: number): string {
  return n < 0 ? `${MINUS}${Math.abs(n)}` : String(n);
}

/**
 * Two scores side by side, mine first: 312, 290 → "312–290". A minus sign
 * next to the en dash reads like a range or a typo ("−4–−11"), so a pair with
 * a negative score is spelled out instead: "−4 to −11", "−6 to 40".
 */
export function formatScorePair(a: number, b: number): string {
  return a < 0 || b < 0 ? `${formatScore(a)} to ${formatScore(b)}` : `${a}–${b}`;
}

/** A score delta: 5 → "+5", −3 → "−3", 0 → "0". */
export function formatDelta(n: number): string {
  return n > 0 ? `+${n}` : formatScore(n);
}
